module.exports = __webpack_public_path__ + "assets/img/tab2_06.54e6243d.jpg";